
































































































import { computed, defineComponent } from '@vue/composition-api';
import { FiatAmount } from '@nimiq/vue-components';
import { useStakingStore } from '../../stores/Staking';
import { useAddressStore } from '../../stores/Address';
import { useRouter } from '../../router';
import { useTotalRewardsFiatValue } from '../../composables/useTotalRewardsFiatValue';
import Amount from '../Amount.vue';
import FiatConvertedAmount from '../FiatConvertedAmount.vue';
import RoundStakingIcon from '../icons/Staking/RoundStakingIcon.vue';
import ValidatorIcon from './ValidatorIcon.vue';
import ValidatorTrustScore from './tooltips/ValidatorTrustScore.vue';
import ValidatorReward from './tooltips/ValidatorReward.vue';
import ShortAddress from '../ShortAddress.vue';
import { useNetworkStore } from '../../stores/Network';
import CircleArrowDownIcon from '../icons/Staking/CircleArrowDownIcon.vue';
import CircleExclamationMarkIcon from '../icons/Staking/CircleExclamationMarkIcon.vue';
import * as Constants from '../../lib/Constants';

export default defineComponent({
    setup() {
        const { activeAddressInfo } = useAddressStore();
        const {
            activeStake: stake,
            activeValidator: validator,
            restakingRewards,
            monthlyRewards,
            stakingEvents,
            isSwitchingValidator,
            pendingOperationNeedsManualStep,
            switchStall,
            switchTargetLabel,
        } = useStakingStore();
        const router = useRouter();
        const { height } = useNetworkStore();

        const availableBalance = computed(() => activeAddressInfo.value?.balance || 0);
        const stakedBalance = computed(() => stake.value
            ? stake.value.activeBalance + stake.value.inactiveBalance + stake.value.retiredBalance
            : 0);

        const percentage = computed(() => {
            const total = availableBalance.value + stakedBalance.value;
            return total > 0 ? Math.round((stakedBalance.value / total) * 100) : 0;
        });

        // Calculate total rewards fiat value using month-based logic via composable
        const { totalRewardsFiatValue, fiatCurrency } = useTotalRewardsFiatValue(
            monthlyRewards,
            stakingEvents,
        );

        const inactiveReleaseTime = computed(() => {
            if (stake.value?.inactiveRelease) {
                // TODO: Take validator jail release into account
                const secondsRemaining = Math.max(0, stake.value.inactiveRelease - height.value);
                const date = new Date(Date.UTC(0, 0, 0, 0, 0, secondsRemaining));
                const hours = date.getUTCHours().toString().padStart(2, '0');
                const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                const seconds = date.getUTCSeconds().toString().padStart(2, '0');
                return [
                    ...(hours !== '' ? [hours] : []),
                    minutes,
                    seconds,
                ].join(':');
            }

            return '00:00';
        });

        const hasUnstakableStake = computed(() => {
            if (!stake.value?.inactiveBalance || !stake.value.inactiveRelease) return false;
            return height.value > stake.value.inactiveRelease;
        });

        const openStakingModal = () => {
            router.push({ name: 'staking' });
        };

        const openValidatorDetailsModal = () => {
            router.push({ name: 'validator-details' });
        };

        return {
            stake,
            validator,
            restakingRewards,
            stakedBalance,
            percentage,
            inactiveReleaseTime,
            hasUnstakableStake,
            isSwitchingValidator,
            pendingOperationNeedsManualStep,
            switchStall,
            switchTargetLabel,
            openStakingModal,
            openValidatorDetailsModal,
            totalRewardsFiatValue,
            fiatCurrency,
            Constants,
        };
    },
    components: {
        Amount,
        FiatConvertedAmount,
        FiatAmount,
        RoundStakingIcon,
        ValidatorIcon,
        ValidatorTrustScore,
        ValidatorReward,
        ShortAddress,
        CircleArrowDownIcon,
        CircleExclamationMarkIcon,
    },
});
